import React from 'react';

export const MediaIconSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_13189_29751)">
      <path
        d="M14.5441 20C14.4041 20 14.2608 19.9825 14.1191 19.945L1.23331 16.4942C0.349972 16.2509 -0.176695 15.3359 0.054972 14.4525L1.68081 8.39254C1.74081 8.17004 1.96914 8.04087 2.19081 8.09754C2.41331 8.1567 2.54497 8.38587 2.48581 8.60754L0.860805 14.6659C0.744972 15.1075 1.00997 15.5675 1.45247 15.69L14.3333 19.1392C14.7758 19.2559 15.2325 18.9925 15.3475 18.5525L15.9983 16.1409C16.0583 15.9184 16.2866 15.7859 16.5091 15.8467C16.7316 15.9067 16.8625 16.1359 16.8033 16.3575L16.1533 18.7659C15.9575 19.5075 15.2825 20 14.5441 20Z"
        fill="currentColor"
      />
      <path
        d="M18.3333 15.0001H4.99998C4.08081 15.0001 3.33331 14.2526 3.33331 13.3334V3.33341C3.33331 2.41425 4.08081 1.66675 4.99998 1.66675H18.3333C19.2525 1.66675 20 2.41425 20 3.33341V13.3334C20 14.2526 19.2525 15.0001 18.3333 15.0001ZM4.99998 2.50008C4.54081 2.50008 4.16665 2.87425 4.16665 3.33341V13.3334C4.16665 13.7926 4.54081 14.1667 4.99998 14.1667H18.3333C18.7925 14.1667 19.1666 13.7926 19.1666 13.3334V3.33341C19.1666 2.87425 18.7925 2.50008 18.3333 2.50008H4.99998Z"
        fill="currentColor"
      />
      <path
        d="M7.49998 7.50008C6.58081 7.50008 5.83331 6.75258 5.83331 5.83341C5.83331 4.91425 6.58081 4.16675 7.49998 4.16675C8.41915 4.16675 9.16665 4.91425 9.16665 5.83341C9.16665 6.75258 8.41915 7.50008 7.49998 7.50008ZM7.49998 5.00008C7.04081 5.00008 6.66665 5.37425 6.66665 5.83341C6.66665 6.29258 7.04081 6.66675 7.49998 6.66675C7.95915 6.66675 8.33331 6.29258 8.33331 5.83341C8.33331 5.37425 7.95915 5.00008 7.49998 5.00008Z"
        fill="currentColor"
      />
      <path
        d="M3.80835 14.1084C3.70169 14.1084 3.59502 14.0676 3.51335 13.9867C3.35085 13.8242 3.35085 13.5601 3.51335 13.3976L7.44919 9.46175C7.92085 8.99008 8.74502 8.99008 9.21669 9.46175L10.3884 10.6334L13.6317 6.74175C13.8675 6.45925 14.2142 6.29508 14.5834 6.29175H14.5925C14.9575 6.29175 15.3034 6.45008 15.5417 6.72758L19.9 11.8126C20.05 11.9867 20.03 12.2501 19.855 12.4001C19.6809 12.5501 19.4184 12.5309 19.2675 12.3551L14.9092 7.27008C14.8284 7.17675 14.7167 7.12508 14.5925 7.12508C14.5059 7.11758 14.3534 7.17758 14.2725 7.27508L10.7367 11.5176C10.6617 11.6076 10.5525 11.6617 10.435 11.6667C10.3167 11.6751 10.2042 11.6284 10.1217 11.5451L8.62752 10.0509C8.47002 9.89425 8.19585 9.89425 8.03835 10.0509L4.10252 13.9867C4.02169 14.0676 3.91502 14.1084 3.80835 14.1084Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_13189_29751">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default MediaIconSvg;
